<template>
    <div class="flats-filter-projects">
        <div class="container">
            <div class="filter-container" v-click-outside="onClickOutside" :class="{'openMobile': isOpenFilterMobile}">
                <div class="mobile-filter-header" v-if="isMobileChecker">
                    <h2><span>{{ filterCMSparams.words_translation.filter_title_filter_mobile }}</span></h2>
                    <a href="#" class="close-link" @click.prevent="closeMobileFilter"><svgIcon name="close" class="icon-svg"/></a>
                </div>
                <div class="btn-find-info" v-if="isMobileChecker">
                    <a href="#" @click.prevent="closeMobileFilter">
                        <flatsFindNum class="btn-find"></flatsFindNum>
                    </a>
                </div>
                <div class="top-items">
                    <!-- FILTER COMPLEX -->
                    <div class="dropwdown-filter-select dropwdown-complex">
                        <span>{{filterCMSparams.flats_filter.sales.name}}</span>
                        <div class="drop-filter-name" :class="{'open' : open_dropComplex}">
                            <a href="#" @click.prevent="open_dropComplex = !open_dropComplex, open_dropPart = false, open_dropClass = false">{{filterCMSparams.flats_filter.sales.name}}</a>
                            <div class="drop-icon"><svgIcon name="arrow-drop" class="icon-svg"/></div>
                        </div>
                        <div class="dropdown-menu" :class="{'open' : open_dropComplex}">
                            <div class="mobile-filter-drop-header" v-if="isMobileChecker">
                                <a href="#" class="close-arrow" @click.prevent="open_dropComplex = !open_dropComplex"><svgIcon name="arrow-drop" class="icon-svg"/></a>
                                <h2>{{filterCMSparams.flats_filter.sales.name}}</h2>
                                <a href="#" class="close-link" @click.prevent="closeMobileFilter"><svgIcon name="close" class="icon-svg"/></a>
                            </div>
                            <div class="drop-checkbox-container">
                                <div class="item-R" v-for="item in filterCMSparams.flats_filter.sales.sales_list">
                                    <input type="checkbox" :id="item.slug" :value="item.slug" v-model="filterFlatsDataBase.complexChecked" @change="filterSalesItems()"> 
                                    <label :for="item.slug">{{item.name}}</label>
                                </div>
                            </div>
                            <div class="btn-save" v-if="isMobileChecker">
                                <a href="#" @click.prevent="open_dropComplex = !open_dropComplex"><span>{{ filterCMSparams.words_translation.filter_btn_save_mobile }}</span></a>
                            </div>
                        </div>
                    </div>
                    <!-- END FILTER COMPLEX -->
                    <!-- FILTER PARTS -->
                    <div class="dropwdown-filter-select dropwdown-part">
                        <span>{{filterCMSparams.flats_filter.parts.name}}</span>
                        <div class="drop-filter-name" :class="{'open' : open_dropPart}">
                            <a href="#" @click.prevent="open_dropPart = !open_dropPart, open_dropComplex = false, open_dropClass = false">{{filterCMSparams.flats_filter.parts.name}}</a>
                            <div class="drop-icon"><svgIcon name="arrow-drop" class="icon-svg"/></div>
                        </div>
                        <div class="dropdown-menu" :class="{'open' : open_dropPart}">
                            <div class="mobile-filter-drop-header" v-if="isMobileChecker">
                                <a href="#" class="close-arrow" @click.prevent="open_dropPart = !open_dropPart"><svgIcon name="arrow-drop" class="icon-svg"/></a>
                                <h2>{{filterCMSparams.flats_filter.parts.name}}</h2>
                                <a href="#" class="close-link" @click.prevent="closeMobileFilter"><svgIcon name="close" class="icon-svg"/></a>
                            </div>
                            <div class="drop-checkbox-container" v-if="globalLang != 'kz/'">
                                <div class="item-R" v-for="item in filterCMSparams.flats_filter.parts.parts_list">
                                    <input type="checkbox" :id="item.value" :value="item.value" v-model="filterFlatsDataBase.partsChecked" @change="filterSalesItems()"> 
                                    <label :for="item.value">{{item.label}}</label>
                                </div>
                            </div>
                            <div class="drop-checkbox-container" v-if="globalLang == 'kz/'">
                                <div class="item-R" v-for="item in filterCMSparams.flats_filter.parts.parts_list_kz">
                                    <input type="checkbox" :id="item.value" :value="item.value" v-model="filterFlatsDataBase.partsChecked" @change="filterSalesItems()"> 
                                    <label :for="item.value">{{item.label}}</label>
                                </div>
                            </div>
                            <div class="btn-save" v-if="isMobileChecker">
                                <a href="#" @click.prevent="open_dropPart = !open_dropPart"><span>{{ filterCMSparams.words_translation.filter_btn_save_mobile }}</span></a>
                            </div>
                        </div>
                    </div>
                    <!-- END FILTER PARTS -->
                    <!-- FILTER SEGMENT -->
                    <div class="dropwdown-filter-select dropdown-segment dropdown-not-drop">
                        <span>{{filterCMSparams.flats_filter.type.name}}</span>
                        <div class="drop-category-nav"> 
                            <ul>
                                <li :class="{'active': filterFlatsDataBase.segment_type == 'all'}" @click="setDataInFlatsDataBase('segment_type', 'all')"><span>{{ filterCMSparams.words_translation.filter_btn_all }}</span></li>
                                <li :class="{'active': filterFlatsDataBase.segment_type == item.slug}" v-for="item in filterCMSparams.flats_filter.type.types_list" @click="setDataInFlatsDataBase('segment_type', item.slug)"><span>{{ item.name }}</span></li>
                            </ul>
                        </div>
                    </div>
                    <!-- END FILTER SEGMENT -->
                    <div class="dropwdown-filter-select dropdown-rooms dropdown-not-drop">
                        <span>{{filterCMSparams.flats_filter.rooms.name}}</span>
                        <div class="filter level-items">
                            <div class="item-R" v-for="item in rooms_filter_arr">
                                <input type="checkbox" :id="'level_' + item" :value="item" v-model="filterFlatsDataBase.roomsQuantities" @change="filterSalesItems()">
                                <label :for="'level_' + item">{{item}}</label>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="dropwdown-filter-select dropwdown-btns" v-if="!isMobileChecker">
                        <div class="drop-checkbox-single">
                            <div class="item-check">
                                <input type="checkbox" id="actions_btn" v-model="filterFlatsDataBase.actions" @change="filterSalesItems()"> 
                                <label for="actions_btn">{{filterCMSparams.flats_filter.sales_btn_desc}}</label>
                            </div>
                        </div>
                    </div> -->
                </div>
                <div class="bottom-items">
                    <!-- RANGE SIZE -->
                    <div class="drop-filter-item drop-filter-size">
                        <span>{{filterCMSparams.flats_filter.size.name}}</span>
                        <div class="filter size-filter range-filter" v-if="filterFlatsDataBase.initRangeSliders">
                            <div class="filter-inputs filter-inputs-size">
                                <div class="input-item">
                                    <span class="start">от</span>
                                    <input type="number" name="minSize" class="form-control" v-model.lazy="filterFlatsDataBase.size[0]" @focusout="validateInput" @keyup.enter="validateInput" oninput="this.value = !!this.value && Math.abs(this.value) >= 0 ? Math.abs(this.value) : null">
                                    <span class="end">м²</span>
                                </div>
                                <div class="input-item">
                                    <span class="start">до</span>
                                    <input type="number" name="maxSize" class="form-control" v-model.lazy="filterFlatsDataBase.size[1]" @focusout="validateInput" @keyup.enter="validateInput" oninput="this.value = !!this.value && Math.abs(this.value) >= 0 ? Math.abs(this.value) : null">
                                    <span class="end">м²</span>
                                </div>
                            </div>
                            <!-- @change="filterSalesItems()" -->
                            <div class="parking-filter-range-slider">
                                <div class="filter" id="SizeFilterFlats">
                                    <input type="text" id="size-filter-flats" name="size"  class="ionRangeSlider" value="" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- RANGE FLOOR -->
                    <div class="drop-filter-item drop-filter-size">
                        <span>{{filterCMSparams.flats_filter.floor.name}}</span>
                        <div class="filter size-filter range-filter" v-if="filterFlatsDataBase.initRangeSliders">
                            <div class="filter-inputs filter-inputs-size">
                                <div class="input-item">
                                    <span class="start">от</span>
                                    <input type="number" name="minFloor" class="form-control" v-model.lazy="filterFlatsDataBase.floor[0]" @focusout="validateInput" @keyup.enter="validateInput" oninput="this.value = !!this.value && Math.abs(this.value) >= 0 ? Math.abs(this.value) : null">
                                </div>
                                <div class="input-item">
                                    <span class="start">до</span>
                                    <input type="number" name="maxFloor" class="form-control" v-model.lazy="filterFlatsDataBase.floor[1]" @focusout="validateInput" @keyup.enter="validateInput" oninput="this.value = !!this.value && Math.abs(this.value) >= 0 ? Math.abs(this.value) : null">
                                </div>
                            </div>
                            <!-- @change="filterSalesItems()" -->
                            <div class="parking-filter-range-slider">
                                <div class="filter" id="FloorFilterFlats">
                                    <input type="text" id="floor-filter-flats" name="size"  class="ionRangeSlider" value="" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- RANGE PRICE -->
                    <div class="drop-filter-item drop-filter-price">
                        <span>{{filterCMSparams.flats_filter.price.name}}</span>
                        <div class="filter size-filter range-filter" v-if="filterFlatsDataBase.initRangeSliders">
                            <div class="filter-inputs filter-inputs-size">
                                <div class="input-item">
                                    <span class="start">от</span>
                                    <input type="number" name="minPrice" class="form-control" v-model.lazy="filterFlatsDataBase.price[0]" @focusout="validateInput" @keyup.enter="validateInput" oninput="this.value = !!this.value && Math.abs(this.value) >= 0 ? Math.abs(this.value) : null">
                                    <span class="end">млн</span>
                                </div>
                                <div class="input-item">
                                    <span class="start">до</span>
                                    <input type="number" name="maxPrice" class="form-control" v-model.lazy="filterFlatsDataBase.price[1]" @focusout="validateInput" @keyup.enter="validateInput" oninput="this.value = !!this.value && Math.abs(this.value) >= 0 ? Math.abs(this.value) : null">
                                    <span class="end">млн</span>
                                </div>
                            </div>
                            <!-- @change="filterSalesItems()" -->
                            <div class="parking-filter-range-slider">
                                <div class="filter" id="PriceFilterFlats">
                                    <input type="text" id="price-filter-flats" name="size"  class="ionRangeSlider" value="" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="drop-filter-item drop-filter-btns">
                        <span>{{filterCMSparams.flats_filter.level.name}}</span>
                        <div class="filter level-items">
                            <div class="item-R" v-for="item in filterCMSparams.flats_filter.level.level">
                                <input type="checkbox" :id="'level_' + item" :value="item" v-model="filterFlatsDataBase.levelQuantities">
                                <label :for="'level_' + item">{{item}}</label>
                            </div>
                        </div>
                    </div> -->
                    <div class="drop-filter-item dropwdown-btns" v-if="isMobileChecker">
                        <div class="drop-checkbox-single">
                            <div class="item-check">
                                <input type="checkbox" id="actions_btn" v-model="filterFlatsDataBase.actions" @change="filterSalesItems()"> 
                                <label for="actions_btn">{{filterCMSparams.flats_filter.sales_btn_desc}}</label>
                            </div>
                        </div>
                    </div>
                    <div class="drop-filter-item drop-filter-reset" v-if="!isMobileChecker">
                        <div class="btn-reset-filter" @click.prevent="reloadFilter">
                            <span>{{ filterCMSparams.words_translation.filter_btn_clearfilter }}</span>
                            <svgIcon name="close-filter" class="icon-close"/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mobile-filter-container" v-if="isMobileChecker">
                <div class="mobile-filter-btns">
                    <a href="#" @click.prevent="openMobileFilter">
                        <span>{{ filterCMSparams.flats_filter.btn_filter_mobile_name }}</span>
                        <svgIcon name="filter" class="icon-svg"/>
                    </a>
                    <a href="#" @click.prevent="openMobileShorting" class="shorting-link" v-if="shortingParam != null">
                        <div class="short-icon">
                            <svgIcon name="shorting-up" class="icon-up" v-if="shortingParam.type == 'ascending'"/>
                            <svgIcon name="shorting-down" class="icon-down" v-if="shortingParam.type == 'descending'"/>
                        </div>
                        <span>{{ shortingParam.name }}</span>
                        <div class="drop-icon"><svgIcon name="arrow-drop" class="icon-svg"/></div>
                    </a>
                    <div class="down-btns">
                        <flatsViewBtns></flatsViewBtns>
                        <div class="btn-reset-filter-mobile" @click="reloadFilter">
                            <span>{{ filterCMSparams.words_translation.filter_btn_clearfilter }}</span>
                            <svgIcon name="close-filter" class="icon-close"/>
                        </div>
                    </div>
                </div>
                <div class="btns-bottom-controls">
                    <flatsFindNum></flatsFindNum>
                </div>
            </div>
            <flatsShorting class="mobile-shorting" :class="{'open' : isOpenShortingMobile}" v-if="isMobileChecker && shortingParam != null && flatsItems != null"></flatsShorting>
            <!-- {{ filterFlatsDataBase }} -->
        </div>
    </div>
</template>

<script>
    import flatsFindNum from '@/components/flats-page/flats-find-num.vue'
    import flatsViewBtns from '@/components/flats-page/flats-view-btns.vue'
    import flatsShorting from '@/components/filters/flats-filter/shorting-filter.vue'
    import svgIcon from '@/components/partials/SvgIcon.vue';
    // import simplebar from 'simplebar-vue';
    // import 'simplebar-vue/dist/simplebar.min.css';
    import {mapGetters} from 'vuex'
    export default {
        name: 'flats-filter-projects',
        components: {
            svgIcon,
            flatsFindNum,
            flatsViewBtns,
            flatsShorting,
            // simplebar,
        },
        data () {
            return {
                globalLang: window.GlobalLang, 
                routerName: this.$router.history.current.name,
                open_dropComplex: false,
                open_dropPart: false,
                SizeFilter: null,
                FloorFilter: null,
                PriceFilter: null,
                rooms_filter_arr: ['ст', '1', '2', '3', '4'],
            }
        },
        computed: mapGetters({
            flatsItems: 'loadFlatsItems',
            flatsItemsDefault: 'loadFlatsItemsDefault',
            shortingParam: 'loadFlatsShortingParams',
            isMobileChecker: 'loadIsMobileChecker',
            //
            filterCMSparams: 'loadFilterCMSparams',
            filterFlatsDataBase: 'loadFilterFlatsData',
            isOpenFilterMobile: 'loadOpenFlatsMobileFilter',
            isOpenShortingMobile: 'loadOpenFlatsMobileShorting',
        }),
        methods: {
            setDataInFlatsDataBase(param, data) {
                this.$store.commit('FilterFlats_update_base', {name: param, data: data});
                this.filterSalesItems();
            },
            onClickOutside() {
                this.open_dropComplex = false;
                this.open_dropPart = false;
            },
            validateInput(e) {
                const minSize_default = parseInt(this.filterCMSparams.flats_filter.size.min);
                const maxSize_default = parseInt(this.filterCMSparams.flats_filter.size.max);
                const minFloor_default = parseInt(this.filterCMSparams.flats_filter.floor.min);
                const maxFloor_default = parseInt(this.filterCMSparams.flats_filter.floor.max);
                const minPrice_default = parseInt(this.filterCMSparams.flats_filter.price.min);
                const maxPrice_default = parseInt(this.filterCMSparams.flats_filter.price.max);
                // console.log(e.target.value, e.target.name, this.filterFlatsDataBase.size[1]);
                //--// -- CHECK FOR SIZE FILTER RANGE
                if (e.target.name == 'minSize') {
                    if (parseInt(e.target.value) < minSize_default) {
                        e.target.value = minSize_default;
                        this.$store.commit('FilterFlats_update_base', {name: 'sizeUpdate', param: 'min', data: minSize_default});
                    } else if (parseInt(e.target.value) > this.filterFlatsDataBase.size[1]) {
                        e.target.value = this.filterFlatsDataBase.size[1];
                        this.$store.commit('FilterFlats_update_base', {name: 'sizeUpdate', param: 'min_max', data: this.filterFlatsDataBase.size[1]});
                    }
                } else if (e.target.name == 'maxSize') {
                    if (parseInt(e.target.value) > maxSize_default) {
                        e.target.value = maxSize_default;
                        this.$store.commit('FilterFlats_update_base', {name: 'sizeUpdate', param: 'max', data: maxSize_default});
                    } else if (parseInt(e.target.value) < this.filterFlatsDataBase.size[0]) {
                        e.target.value = this.filterFlatsDataBase.size[0];
                        this.$store.commit('FilterFlats_update_base', {name: 'sizeUpdate', param: 'max_max', data: this.filterFlatsDataBase.size[0]});
                    }
                } 
                //--//-- CHECK FOR FLOOR FILTER RANGE
                else if (e.target.name == 'minFloor') {
                    if (parseInt(e.target.value) < minFloor_default) {
                        e.target.value = minFloor_default;
                        this.$store.commit('FilterFlats_update_base', {name: 'floorUpdate', param: 'min', data: minFloor_default});
                    } 
                    else if (parseInt(e.target.value) > this.filterFlatsDataBase.floor[1]) {
                        e.target.value = this.filterFlatsDataBase.floor[1];
                        this.$store.commit('FilterFlats_update_base', {name: 'floorUpdate', param: 'min_max', data: this.filterFlatsDataBase.floor[1]});
                    } 
                }
                else if (e.target.name == 'maxFloor') {
                    if (parseInt(e.target.value) > maxFloor_default) {
                        e.target.value = maxFloor_default;
                        this.$store.commit('FilterSales_update_base', {name: 'floorUpdate', param: 'max', data: maxFloor_default});
                    } else if (parseInt(e.target.value) < this.filterFlatsDataBase.floor[0]) {
                        e.target.value = this.filterFlatsDataBase.floor[0];
                        this.$store.commit('FilterSales_update_base', {name: 'floorUpdate', param: 'max_max', data: this.filterFlatsDataBase.floor[0]});
                    }
                }
                //--//-- CHECK FOR PRICE FILTER RANGE
                else if (e.target.name == 'minPrice') {
                    if (parseInt(e.target.value) < minPrice_default) {
                        e.target.value = minPrice_default;
                        this.$store.commit('FilterFlats_update_base', {name: 'priceUpdate', param: 'min', data: minPrice_default});
                    } 
                    else if (parseInt(e.target.value) > this.filterFlatsDataBase.price[1]) {
                        e.target.value = this.filterFlatsDataBase.price[1];
                        this.$store.commit('FilterFlats_update_base', {name: 'priceUpdate', param: 'min_max', data: this.filterFlatsDataBase.price[1]});
                    } 
                }
                else if (e.target.name == 'maxPrice') {
                    if (parseInt(e.target.value) > maxPrice_default) {
                        e.target.value = maxPrice_default;
                        this.$store.commit('FilterFlats_update_base', {name: 'priceUpdate', param: 'max', data: maxPrice_default});
                    } else if (parseInt(e.target.value) < this.filterFlatsDataBase.price[0]) {
                        e.target.value = this.filterFlatsDataBase.price[0];
                        this.$store.commit('FilterFlats_update_base', {name: 'priceUpdate', param: 'max_max', data: this.filterFlatsDataBase.price[0]});
                    }
                }

                this.updateIONrangeSlider();
                this.filterSalesItems();
            },
            BuildIonRangeSlider() {
                var _self = this;
                // console.log(_self.filterMinMaxParams, '212312312123123')
                _self.SizeFilter = $('#size-filter-flats');
                _self.FloorFilter = $('#floor-filter-flats');
                _self.PriceFilter = $('#price-filter-flats');
                _self.SizeFilter.ionRangeSlider({
                    type: "double",
                    min: parseInt(_self.filterCMSparams.flats_filter.size.min),
                    max: parseInt(_self.filterCMSparams.flats_filter.size.max),
                    from: _self.filterFlatsDataBase.size[0],
                    to: _self.filterFlatsDataBase.size[1],
                    step: 1,
                    hide_min_max: true,
                    onChange: function (data) {
                        _self.$store.commit('FilterFlats_update_base', {name: 'sizeUpdate', param: 'rangeSlider', data: {min: data.from, max: data.to}})
                        _self.filterSalesItems(); 
                    },
                    // onUpdate: function (data) {
                    //     // console.log(data, 'update')
                    //     _self.$store.commit('FilterDataUpdate', {type: 'size-filter', min: data.from, max: data.to})
                    //     // _self.updateFilterDataBase();
                    // },
                });
                _self.FloorFilter.ionRangeSlider({
                    type: "double",
                    min: parseInt(_self.filterCMSparams.flats_filter.floor.min),
                    max: parseInt(_self.filterCMSparams.flats_filter.floor.max),
                    from: _self.filterFlatsDataBase.floor[0],
                    to: _self.filterFlatsDataBase.floor[1],
                    step: 1,
                    hide_min_max: true,
                    onChange: function (data) {
                        _self.$store.commit('FilterFlats_update_base', {name: 'floorUpdate', param: 'rangeSlider', data: {min: data.from, max: data.to}})
                        _self.filterSalesItems(); 
                    },
                    // onUpdate: function (data) {
                    //     // console.log(data, 'update')
                    //     _self.$store.commit('FilterDataUpdate', {type: 'size-filter', min: data.from, max: data.to})
                    //     // _self.updateFilterDataBase();
                    // },
                });
                _self.PriceFilter.ionRangeSlider({
                    type: "double",
                    min: parseInt(_self.filterCMSparams.flats_filter.price.min),
                    max: parseInt(_self.filterCMSparams.flats_filter.price.max),
                    from: _self.filterFlatsDataBase.price[0],
                    to: _self.filterFlatsDataBase.price[1],
                    step: 1,
                    hide_min_max: true,
                    onChange: function (data) {
                        _self.$store.commit('FilterFlats_update_base', {name: 'priceUpdate', param: 'rangeSlider', data: {min: data.from, max: data.to}})
                        _self.filterSalesItems(); 
                    },
                    // onUpdate: function (data) {
                    //     // console.log(data, 'update')
                    //     _self.$store.commit('FilterDataUpdate', {type: 'size-filter', min: data.from, max: data.to})
                    //     // _self.updateFilterDataBase();
                    // },
                });

            },
            // сброс всех range фильтров при динамических изменения данных мимальных и максимальных значениях фильтра
            updateIONrangeSlider() {
                var _self = this;
                _self.SizeFilter.data("ionRangeSlider").update({
                    from: _self.filterFlatsDataBase.size[0],
                    to: _self.filterFlatsDataBase.size[1],
                });
                _self.FloorFilter.data("ionRangeSlider").update({
                    from: _self.filterFlatsDataBase.floor[0],
                    to: _self.filterFlatsDataBase.floor[1],
                });
                _self.PriceFilter.data("ionRangeSlider").update({
                    from: _self.filterFlatsDataBase.price[0],
                    to: _self.filterFlatsDataBase.price[1],
                });
            },
            resetIONrangeSlider() {
                var _self = this;
                _self.SizeFilter.data("ionRangeSlider").update({
                    min: parseInt(_self.filterCMSparams.flats_filter.size.min),
                    max: parseInt(_self.filterCMSparams.flats_filter.size.max),
                    from: parseInt(_self.filterCMSparams.flats_filter.size.min),
                    to: parseInt(_self.filterCMSparams.flats_filter.size.max),
                });
                _self.FloorFilter.data("ionRangeSlider").update({
                    min: parseInt(_self.filterCMSparams.flats_filter.floor.min),
                    max: parseInt(_self.filterCMSparams.flats_filter.floor.max),
                    from: parseInt(_self.filterCMSparams.flats_filter.floor.min),
                    to: parseInt(_self.filterCMSparams.flats_filter.floor.max),
                });
                _self.PriceFilter.data("ionRangeSlider").update({
                    min: parseInt(_self.filterCMSparams.flats_filter.price.min),
                    max: parseInt(_self.filterCMSparams.flats_filter.price.max),
                    from: parseInt(_self.filterCMSparams.flats_filter.price.min),
                    to: parseInt(_self.filterCMSparams.flats_filter.price.max),
                });
            },
            reloadFilter() {
                this.$store.commit('setFlatsItemsByShorting', {'shorting_params' : this.shortingParam, 'items' : this.flatsItemsDefault});
                this.$store.commit('ReloadFlatsFilter');
                this.resetIONrangeSlider();
                // this.filterSalesItems();
            },  
            filterSalesItems() {
                var flatsItems = this.flatsItemsDefault;
                const filteredData = flatsItems.filter(item => {
                    return (!this.filterFlatsDataBase.complexChecked.length || this.filterFlatsDataBase.complexChecked.includes(item.project.slug)) &&
                           (!this.filterFlatsDataBase.partsChecked.length || this.filterFlatsDataBase.partsChecked.includes(item.part.value)) &&
                           (this.filterFlatsDataBase.segment_type === 'all' ? true : item.class.slug == this.filterFlatsDataBase.segment_type) &&
                           (!this.filterFlatsDataBase.roomsQuantities.length || this.filterFlatsDataBase.roomsQuantities.includes(item.rooms.label)) &&
                           (parseFloat(item.size) >= this.filterFlatsDataBase.size[0] && parseFloat(item.size) <= this.filterFlatsDataBase.size[1]) &&
                           (parseFloat(item.price) >= this.filterFlatsDataBase.price[0] && parseFloat(item.price) <= this.filterFlatsDataBase.price[1]) &&
                           (item.floor.some(value => parseInt(value) >= this.filterFlatsDataBase.floor[0] && parseInt(value) <= this.filterFlatsDataBase.floor[1]))
                        //    (this.filterFlatsDataBase.actions === false ? true : item.sales_init == this.filterFlatsDataBase.actions)
                });
                // console.log(filteredData)
                this.$store.commit('setFlatsItemsByShorting', {'shorting_params' : this.shortingParam, 'items' : filteredData});
            },
            openMobileFilter() {
                this.$store.commit('OpenFlatsMobileFilter', true);
                document.getElementsByTagName('body')[0].classList.add('overlay-open');
                document.getElementById('header').classList.add('hideMobile');
                document.getElementById('footer').classList.add('hideMobile');
            },
            closeMobileFilter() {
                this.$store.commit('OpenFlatsMobileFilter', false);
                document.getElementsByTagName('body')[0].classList.remove('overlay-open');
                document.getElementById('header').classList.remove('hideMobile');
                document.getElementById('footer').classList.remove('hideMobile');
            },
            openMobileShorting() {
                this.$store.commit('OpenFlatsMobileShorting', true);
                document.getElementsByTagName('body')[0].classList.add('overlay-open');
                document.getElementById('header').classList.add('hideMobile');
                document.getElementById('footer').classList.add('hideMobile');
            },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
            this.BuildIonRangeSlider();
            this.$store.commit('setFlatsShortingParams', this.filterCMSparams.shorting_names.price_up);
            // this.$store.commit('setFlatsItemsByShorting', {'shorting_params' : this.shortingParam, 'items' : this.flatsItems});
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/filters/flats-filter/flats-filter.scss';
    @import '@/styles/components/filters/flats-filter/respond/flats-filter-respond.scss';
    // @import '@/styles/components/filters/sales-projects/respond/sales-filter-respond.scss';
</style>